import { Component } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Router } from '@angular/router';
import { UserService } from 'app/shared/services/user.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@AutoUnsubscribe()
@Component({
  selector: 'content-events',
  templateUrl: './content-events.component.html',
  styleUrls: ['./content-events.component.scss']
})

export class ContentEventsComponent {

  constructor(public router: Router, public userService: UserService, public ga: GoogleAnalyticsService) { }

  ngOnDestroy() {

  }

  ngOnInit() {

  }

}
